var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.event.show && _vm.event.filter
    ? _c(
        "article",
        {
          staticClass:
            "TcEventItem bg-white p-5 flex relative gap-5 shadow-md overflow-hidden",
          style: { "border-left": "8px solid " + _vm.event.color }
        },
        [
          _c("div", [
            _c("div", { staticClass: "text-5xl font-bold mb-2" }, [
              _vm._v(_vm._s(_vm.getDay))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-xl" }, [
              _vm._v(_vm._s(_vm.getMonth))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-grow" }, [
            _c("div", [
              _c("div", { staticClass: "text-xl font-bold" }, [
                _vm._v(_vm._s(_vm.event.name))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex mt-1 mb-10 items-center" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "text-white text-sm py-1 px-6 mr-3 rounded-full",
                    style: { "background-color": _vm.event.color }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.event.category_name) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.event.amount
                  ? _c("div", { staticClass: "coin-euro" }, [
                      _vm._v("Precio: "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.event.amount.strToEuro()))
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "host mb-2" }, [
                _vm._v("Organiza: " + _vm._s(_vm.event.host_name))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "location mb-2" }, [
                _vm._v(_vm._s(_vm.event.venue))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "group",
                  domProps: { innerHTML: _vm._s(_vm.getAvailable) }
                },
                [_vm._v("Plazas")]
              )
            ])
          ]),
          _vm._v(" "),
          !_vm.hide_buttons
            ? _c("div", { staticClass: "flex flex-col gap-3" }, [
                !_vm.subscribed
                  ? _c(
                      "button",
                      {
                        staticClass: "btn-sm w-full",
                        on: {
                          click: function($event) {
                            return _vm.$parent.subscribeEvent(_vm.event)
                          }
                        }
                      },
                      [_vm._v("Inscribirme")]
                    )
                  : _c(
                      "span",
                      { staticClass: "text-center font-bold text-green-500" },
                      [_vm._v(" Ya inscrito ")]
                    ),
                _vm._v(" "),
                !_vm.hide_info
                  ? _c(
                      "button",
                      {
                        staticClass: "btn-sm w-full btn-secondary",
                        on: {
                          click: function($event) {
                            return _vm.$parent.moreInfo(_vm.event)
                          }
                        }
                      },
                      [_vm._v("Más información")]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasPaymentStatus
            ? _c(
                "div",
                {
                  staticClass: "paid-status",
                  class: { payed: _vm.isPaid, unpayed: !_vm.isPaid }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.isPaid ? "PAGADO" : "PENDIENTE DE PAGO") +
                      "\n    "
                  )
                ]
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }